import { array, bool, object, string } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import ApprovalButton from './ApprovalButton'
import ApprovalStatusLabel from './ApprovalStatusLabel'
import {
  itemListTitle,
  markLastIncompleteItem,
  shouldRenderApprovalButton,
} from './helpers'
import ItemContainer from './ItemContainer'

import './styles.scss'

const shouldDisplayOptions = (props, isLimitedRole) =>
  !isLimitedRole &&
  props.requires_all_approvals &&
  props.workflow &&
  props.workflow.content_approval_status === 'declined' &&
  props.workflow.status === 'active'

const Content = ({
  currentUser,
  isLimitedRole,
  phaseItems,
  requiresAllApprovals,
  theme,
  ...otherProps
}) => {
  const modifiedItems = markLastIncompleteItem(phaseItems)

  return (
    <div className={kuiperClassNames('phase-content')}>
      <ApprovalStatusLabel phase={otherProps} />

      <ApprovalButton
        {...otherProps}
        isLimitedRole={isLimitedRole}
        phaseItems={phaseItems}
        requiresAllApprovals={requiresAllApprovals}
        shouldDisplayOptions={shouldDisplayOptions(otherProps, isLimitedRole)}
        shouldRender={shouldRenderApprovalButton(otherProps)}
        theme={theme}
      />

      <div className={kuiperClassNames('phase-item-groups')}>
        <ItemContainer
          {...otherProps}
          currentUser={currentUser}
          phaseItems={modifiedItems}
          onChangeTaskText={otherProps.onChangeTaskText}
          onChangeTaskValue={otherProps.onChangeTaskValue}
          placeholder={otherProps.placeholder}
          renderTitle={true}
          theme={theme}
          title={itemListTitle(otherProps)}
          withMenu={false}
        />
      </div>
    </div>
  )
}

Content.propTypes = {
  currentUser: object,
  isLimitedRole: bool,
  phaseItems: array,
  requiresAllApprovals: bool,
  theme: string,
}

export default Content
